import React from 'react'

const Announces = (): JSX.Element => <div>Announces</div>

export default Announces
